import Vue from 'vue'
import { getBilDetail, getBillConfirm, getAccountInfo, getRefundContractLink } from "@/api/billConfirm";
import { Toast } from "vant";

const state = {
    billDetail: {},
    accountInfo: {},
    refundContract: {},
}
const mutations = {
    /**
     * 为state项赋值
     * @param state
     * @param data
     */
    setStateItem(state, data) {
        state[data.key] = data.value
    },

}
const actions = {
    /**
     * 获取账单
     */
    async getBilDetail({ state, commit }, data) {
        try {
            const res = await getBilDetail(data)
            if (res.data.code == 200) {
                commit('setStateItem', { key: 'billDetail', value: res.data.data })
                data.cb && data.cb()
                return res.data.data
            } else {
                Toast(res.data.message)
                return false
            }
        } catch (e) {
            return false
        }
    },
    /**
     * 确认账单
     */
    async getBillConfirm({ state, commit }, data) {
        try {
            const res = await getBillConfirm(data)
            if (res.data.code == 200) {
                data.cb && data.cb()
                return res.data.data
            } else {
                Toast(res.data.message)
                return false
            }
        } catch (e) {
            return false
        }
    },

    /**
     * 查询对公账户
     */
    async getAccountInfo({ commit }, params) {
        try {
            const res = await getAccountInfo(params)
            if (res.data.code === '200') {
                commit('setStateItem', { key: 'accountInfo', value: res.data.data })
                params.cb() ? params.cb() : ''
                return true
            } else {
                Toast(res.data.message)
                return false
            }
        } catch (e) {
            console.log(e)
        }
    },

    /**
     * 获取账单退款合同链接接口
     * 非科锐的猎企确认账单时需要签署退款合同，签署完成后自动确认账单
     */
    async getRefundContractLink({ commit }, params) {
        try {
            const res = await getRefundContractLink(params)
            if (res.data.code === '200') {
                commit('setStateItem', { key: 'refundContract', value: res.data.data })
                params.cb && params.cb()
            } else {
                Toast(res.data.message)
            }
        } catch (e) {
            console.log(e)
        }
    },

}
export default {
    state,
    actions,
    mutations,
    namespaced: true,
}